import { StatusTag } from "../../../../components/chips/status-tag";
import { CONST_PROJECT_STATUS_LIST } from "../../../../constants/lists";
import { getProjectStatus } from "../../../../services/utils";

function ProjectStatus({
  data,
  labelField = "label",
  width = "100%",
}) {
  const status = getProjectStatus(data);
  const statusConfig = CONST_PROJECT_STATUS_LIST[status];

  if (!statusConfig?.[labelField]) return null;

  const { fontColor, tagBgColor } = statusConfig;

  return (
    <StatusTag
      text={statusConfig[labelField]}
      fontColor={fontColor}
      bgColor={tagBgColor}
      width={width}
    />
  );
}

export { ProjectStatus };
